import { services, testimonials } from './mock';

const serviceIds = [
  'terraces',
  'pool_surrounds',
  'driveways',
  'stairs_steps',
  'balconies',
  'walkways_patios',
  'garages'
];

export const staticServices = services.map((service, index) => ({
  ...service,
  service_id: serviceIds[index],
  image_url: service.image,
  display_order: index + 1,
  is_active: true
}));

export const staticTestimonials = testimonials;

const galleryGroups = [
  {
    category: 'Terraces',
    imagePrefix: 'stone-carpet-terrace-costa-del-sol',
    locations: ['Marbella', 'Estepona', 'Malaga', 'Fuengirola', 'Marbella', 'Mijas']
  },
  {
    category: 'Pool Surrounds',
    imagePrefix: 'stone-carpet-pool-surrounds-costa-del-sol',
    locations: ['Marbella', 'Estepona', 'Benalmadena', 'Fuengirola', 'Marbella', 'Torremolinos']
  },
  {
    category: 'Driveways',
    imagePrefix: 'stone-carpet-driveway-costa-del-sol',
    locations: ['Marbella', 'Estepona', 'Malaga', 'Fuengirola', 'Marbella', 'Mijas']
  },
  {
    category: 'Stairs & Steps',
    imagePrefix: 'stone-carpet-stairs-costa-del-sol',
    locations: ['Marbella', 'Estepona', 'Malaga', 'Fuengirola', 'Marbella', 'Benalmadena']
  },
  {
    category: 'Balconies',
    imagePrefix: 'stone-carpet-balcony-costa-del-sol',
    locations: ['Marbella', 'Estepona', 'Malaga', 'Fuengirola', 'Marbella', 'Mijas']
  },
  {
    category: 'Walkways & Patios',
    imagePrefix: 'stone-carpet-walkway-patio-costa-del-sol',
    locations: ['Marbella', 'Estepona', 'Malaga', 'Fuengirola', 'Marbella', 'Benalmadena']
  },
  {
    category: 'Garages',
    imagePrefix: 'stone-carpet-garage-costa-del-sol',
    locations: ['Marbella', 'Estepona', 'Malaga', 'Fuengirola', 'Marbella', 'Mijas']
  }
];

export const staticGalleryItems = galleryGroups.flatMap((group, groupIndex) =>
  group.locations.map((location, itemIndex) => {
    const displayOrder = groupIndex * 6 + itemIndex + 1;
    const translationKey = String(displayOrder).padStart(3, '0');

    return {
      id: `gallery_${translationKey}`,
      translationKey,
      category: group.category,
      location,
      image_url: `/images/${group.imagePrefix}-${itemIndex + 1}.webp`,
      is_featured: itemIndex === 0,
      is_active: true,
      display_order: displayOrder
    };
  })
);

export const staticGalleryCategories = ['All', ...galleryGroups.map((group) => group.category)];
